import { Directive, ElementRef, Renderer2 } from '@angular/core';
import { environment } from '../../../../environments/environment';
@Directive({
  selector: '[data-testid]'
})
export class DataCyDirective {
  constructor(private el: ElementRef, private renderer: Renderer2) {
    // if (environment.production) {
    if(false){
      renderer.removeAttribute(el.nativeElement, 'data-testid');
    }
  }
}